import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StatementMessagingComponent } from './components/statement-messaging/statement-messaging.component';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { LoginErrorComponent } from './components/login-error/login-error.component';
import { AuthGuard, canCreateGuard, canEditGuard, canViewGuard } from './core/guards/auth.guard';
import { MessageAddComponent } from './components/message-add/message-add.component';
import { UnsavedChangesGuard } from './core/guards/add-message-unsaved-form.guard';
import { ViewUpdateMessageComponent } from './components/view-update-message/view-update-message.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: StatementMessagingComponent, //protected end point
    canActivate: [AuthGuard, canViewGuard], //  Requires view access
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
  },
  {
    path: 'login-error',
    component: LoginErrorComponent,
  },
  {
    path: 'message',
    children: [
      {
        path: 'add',
        component: MessageAddComponent, // Child route
        canActivate: [AuthGuard, canCreateGuard], //  Requires view access
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: 'view',
        component: ViewUpdateMessageComponent, // Child route
        canActivate: [AuthGuard, canViewGuard], //  Requires view/edit access
        canDeactivate: [UnsavedChangesGuard],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top', // restores scroll to top on navigation
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
